import request from '@/libs/request'

//预警 记录 列表
export function alertRecordsListApi (data) {
  return request({
    url: `alert/alertRecords`,
    method: 'get',
    params: data
  })
}

//预警 记录 详情
export function alertRecordsInfoApi (id) {
  return request({
    url: `alert/alertRecords/` + id,
    method: 'get'
  })
}


//预警 今日预警
export function alertTodayApi () {
  return request({
    url: `alert/alertApi/today`,
    method: 'get',
  })
}




